"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var common_1 = require("docs/common");
exports.PropertiesButton = function () { return (React.createElement(common_1.PropertyTable, null,
    React.createElement(common_1.Property, { name: "flat", type: "bool", description: "When true, button will look like a link. Without elevation or background. Background will appear only when clicked." }),
    React.createElement(common_1.Property, { name: "children", type: "any", defaultValue: "Button", description: "Label of the button or anything else." }))); };
exports.PropertiesButton.displayName = 'PropertiesButton';



//////////////////
// WEBPACK FOOTER
// ./src/docs/pages/ComponentButtonPage/PropertiesButton.tsx
// module id = 638
// module chunks = 0